var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-flex',{attrs:{"row":"","wrap":"","align-top":"","justify-center":""}},[_c('Table',{attrs:{"elements":_vm.startups,"titleHeader":_vm.header,"addNewTitle":_vm.addNewStartupTitle,"showButton":_vm.showButton,"searchCallback":_vm.searchStartups,"clickCallback":_vm.navigate,"searchStartup":_vm.searchStartups}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }